// @ts-nocheck
import { apiRequest } from "../../../services/apiService";
import { USER_ROLES } from "../../../staticData/userRoles";
import {
  FETCH_DASHBOARD_EVENTS_FAILURE,
  FETCH_DASHBOARD_EVENTS_REQUEST,
  FETCH_DASHBOARD_EVENTS_SUCCESS,
} from "../../constants/event/dashboard";

export const getDashboardEventsAction = ({
  params,
  additionalData,
  // beforeCallback,
  // afterCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_DASHBOARD_EVENTS_REQUEST, payload: additionalData });
    // Post-unify: uses activeRole (the legacy userRole field was removed — task #100).
    const activeRole = getState()?.auth?.activeRole;
    const { response, error } = await apiRequest({
      method: "GET",
      url:
        activeRole === USER_ROLES.CLIENT
          ? `getAllEventsClientSide`
          : `getAllEvents`,
      params,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_DASHBOARD_EVENTS_SUCCESS,
        payload: response?.data,
      });
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_DASHBOARD_EVENTS_FAILURE });
      failureCallback?.();
    }
  };
};